import { render } from "./EtatProduitsSorties.vue?vue&type=template&id=67c487a3&ts=true"
import script from "./EtatProduitsSorties.vue?vue&type=script&lang=ts"
export * from "./EtatProduitsSorties.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__